import { ActionReducerMap } from '@ngrx/store';

import { containerEntityReducer } from './container-entity.reducer';
import { containerStructureReducer } from './container-structure.reducer';
import { ContainerState } from './container.state';
import { libraryNotesBeingEditedReducer } from './library-notes-being-edited.reducer';
import { listsByIdReducer } from './lists-by-id.reducer';
import { loadableItemPagesReducer } from './loadable-item-pages.reducer';
import { noteItemsBeingEditedReducer } from './note-items-being-edited.reducer';
import { sectionsBeingEditedReducer } from './sections-being-edited.reducer';
import { sectionsByIdReducer } from './sections-by-id.reducer';
import { studentNotesBeingEditedReducer } from './student-notes-being-edited.reducer';
import { tagsBeingEditedReducer } from './tags-being-edited.reducer';

export const containerReducer: ActionReducerMap<ContainerState> = {
  container: containerEntityReducer,
  containerStructure: containerStructureReducer,
  noteItemsBeingEdited: noteItemsBeingEditedReducer,
  tagsBeingEdited: tagsBeingEditedReducer,
  studentNotesBeingEdited: studentNotesBeingEditedReducer,
  sectionsBeingEdited: sectionsBeingEditedReducer,
  sectionsById: sectionsByIdReducer,
  libraryNotesBeingEdited: libraryNotesBeingEditedReducer,
  listsById: listsByIdReducer,
  loadableItemPagesByOffset: loadableItemPagesReducer,
};
